<template>
  <div class="content">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Document Comments</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="newComment()">New Comment</base-button>
          <base-button size="sm" type="neutral" @click="$router.back()">Back</base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
      <b-row>
        <b-col>
          <div class="card-wrapper">
            <document-view-form></document-view-form>
          </div>
        </b-col>
      </b-row>
      </div>

      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Document Comment</h3>
          </template>
          <div>
            <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page">Upload New Document
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Search...">
                </base-input>
              </div>
            </b-col>
            <b-col class="text-right">
              <base-button size="sm" type="primary" @click="newComment()">New Comment</base-button><br>
            <br></b-col>
            <el-table :data="queriedData"
                      row-key="project_id"
                      header-row-class-name="thead-light"
                      @sort-change="sortChange">

              <el-table-column label="No"
                             min-width="70px"
                             prop="document_comment_sequence"
                             sortable>
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center">
                        <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm">{{row.document_comment_sequence}}</span>
                        </b-media-body>
                    </b-media>

                </template>
              </el-table-column>

              <el-table-column label="comment"
                             min-width="500px"
                             prop="document_comment"
                             sortable>
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center">
                        <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm">{{row.document_comment}}</span>
                        </b-media-body>
                    </b-media>
                </template>
              </el-table-column>

              <el-table-column label="Comment By"
                             min-width="170px"
                             prop="created_by.email"
                             sortable>
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center">
                        <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm">{{row.created_by.email}}</span>
                        </b-media-body>
                    </b-media>
                </template>
              </el-table-column>

              <el-table-column min-width="100px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">

                  <base-button
                    @click.native="editComment($index, row)" size="sm" type="primary">
                    Edit Comment
                  </base-button>
                  <!-- <base-button
                    @click.native="downloadDocument($index, row)" size="sm" type="primary">
                    Download Document
                  </base-button> -->
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)">
            </base-pagination>
             <!-- <div>
              <h5 class="text-danger"> Note :
                  <i>
                  Please Create at least ONE Project Template & ONE Project Template Details before you can proceed POPULATE / IMPORT to prevent any Error. Go to NEW Template Then "Detail Listing" >> "New Template Details".
                  </i>
              </h5>
            </div> -->
          </div>
        </card>
      </div>
    </b-container>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import standardPaginationMix from '@/assets/js/standardPaginationMix.js'
import Fuse from 'fuse.js';
import axios from 'axios'
import DocumentViewForm from './DocumentViewForm.vue';
import {LoginURL, clientId, clientSecret, apiDomain, getHeader, fuseData} from '@/assets/js/config.js'

export default {
  mixins: [standardPaginationMix],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    "document-view-form": DocumentViewForm,
  },
  created()
  {
      this.getCreateData()
  },
  data() {
    return {
      model: {
          document_detail_id: null,
      },
      propsToSearch:
      [
        'document_classification_code',
        'project.project_code',
        'group.group_code',
        'site.site_code',
        'milestone.milestone_code',
        'document_type.document_type_code',
        'document_version',
        'document_mandatory',
        'status.status_code',
      ],
      tableColumns: [],
      tableData: [],
      selectedRows: []
    };
  },
  methods: {
    getCreateData()
    {
        this.model.document_detail_id = this.$route.params.id

        axios.get(apiDomain + 'document/document_comment.show_by_document_detail/' + this.model.document_detail_id , { headers: getHeader() })
        .then ( response => {
        if (response.status === 200)
        {
            this.tableData = response.data.data
            this.fuseData()
        }
        })
        .catch ( error => {
        console.log(error.response.status)
        if ( error.response.status == 401)
        {
            this.$router.push('/login')
        }
        });
    },
    newComment()
    {
      this.$router.push({path: '/documentCommentNew/' + this.model.document_detail_id })
    },
    editComment(index, row)
    {
      this.$router.push({path: '/documentCommentEdit/' + row.document_comment_id })
    },
    newUpload()
    {
      this.$router.push({path: 'newUpload/' + this.document_id })
    },
    fuseData()
    {
        this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
        });
    },
    paginationChanged(page)
    {
        this.pagination.currentPage = page
    },
    editDocument(index, row)
    {
        this.$router.push({path: 'documentEdit/' + this.document_id })
    },
    selectionChange(selectedRows)
    {
        this.selectedRows = selectedRows
    }
  }
};
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
</style>
